import { FormControl, MenuItem, Select } from "@mui/material";
import { useLanguage } from '../../../contexts/LanguageContext';
import translations from './JobStatusFilter.translations.json';

type SupportedLanguage = keyof typeof translations;

export type JobStatus =  "OPEN" | "CLOSED";

interface JobStatusFilterProps {
  value: JobStatus;
  onChange: (status: JobStatus) => void;
}

const JobStatusFilter = ({ value, onChange }: JobStatusFilterProps) => {
  const { language } = useLanguage();
  const content = translations[language as SupportedLanguage] || translations.en;
  return (
    <FormControl size="small" sx={{ minWidth: 140 }}>
      <Select
        value={value}
        onChange={(e) => onChange(e.target.value as JobStatus)}
        displayEmpty
        sx={{
          bgcolor: "#121824",
          color: "#fff",
          borderRadius: "8px",
          "& .MuiOutlinedInput-notchedOutline": { borderColor: "#2a3245" },
          "& .MuiSvgIcon-root": { color: "#fff" },
        }}
      >
        <MenuItem value="">{content.all}</MenuItem>
        <MenuItem value="OPEN">{content.open}</MenuItem>
        <MenuItem value="CLOSED">{content.closed}</MenuItem>
      </Select>
    </FormControl>
  );
};

export default JobStatusFilter;
